<template>
  <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y
    min-width="auto">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field :value="value" @input="onInput" :label="label" :persistent-hint="persistentHint" :hint="hint"
        prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
    </template>
    <v-date-picker landscape :value="value" :min="minDate" @input="onInput"></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: 'VDateField',
  props: {
    value: {
      type: String,
    },
    label: {
      type: String,
    },
    hint: {
      type: String,
    },
    persistentHint: {
      type: Boolean,
    },
  },
  data() {
    return {
      menu: false,
    };
  },
  computed: {
    minDate() {
      const now = new Date();
      now.setDate(now.getDate() + 1);

      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    },
  },
  methods: {
    onInput(newVal) {
      this.menu = false;
      this.$emit('input', newVal);
    },
  },
};
</script>
